
import { MetricWithTrend } from '@/types/dashboard';

/**
 * Calculates trend information for a metric value
 */
export function calculateTrend(key: string, currentValue: number, previousValue: number = 0): MetricWithTrend {
  const diff = currentValue - previousValue;

  // Calculate percentage change
  // If previous value is 0, we can't calculate a percentage increase (it would be infinity)
  // If both are 0, change is 0%
  let percentChange = 0;

  if (previousValue > 0) {
    percentChange = Math.round((diff / previousValue) * 100);
  } else if (currentValue > 0) {
    // If previous was 0 and current is > 0, it's a 100% increase (effectively infinite, but 100% is a safe fallback for UI)
    percentChange = 100;
  }

  // Don't store state anymore, just calculate based on inputs

  return {
    value: currentValue,
    trend: diff > 0 ? 'up' : diff < 0 ? 'down' : 'none',
    percentChange: Math.abs(percentChange)
  };
}
